import en from "./i18n/en";
import pl from "./i18n/pl";

export const SUPPORTED_LANGUAGES = ["en", "pl"];

export const LANGUAGE_LABELS = {
    en: "English",
    pl: "Polski",
};

export const LANGUAGE_DOMAINS = {
    en: "xsiadron.com",
    pl: "xsiadron.pl",
};

export const translations = {
    en,
    pl,
};
